'use client';

/* eslint-disable import/order */
/* eslint-disable boundaries/element-types */
/* eslint-disable import/no-internal-modules */
import React, { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import Slider from 'react-slick';
import he from 'he';

import { Card } from '@/entities/card';

import { useGetViewedQuery } from '@shared/api';
import type { Locale } from '@shared/libs';
import { NoteInfo } from '@shared/types';
import { H2 } from '@shared/ui';

import styles from './recently-viewed.module.css';

type Props = {
  locale: Locale;
  id: number;
};

const RecentlyViewed = ({ locale, id }: Props) => {
  const isTabletOrMobile = useMediaQuery({ maxWidth: 768 });
  const isMobile = useMediaQuery({ maxWidth: 480 });

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    // eslint-disable-next-line no-nested-ternary
    slidesToShow: isMobile ? 1 : isTabletOrMobile ? 2.5 : 4,
    slidesToScroll: 1,
    autoplay: false,
    vertical: false,
    swipeToSlide: true,
    swipe: true,
  };

  const { data: viewed } = useGetViewedQuery();

  const filterData = useMemo(() => viewed?.filter((item) => item.id !== id), [viewed, id]);

  if (!filterData?.length) return null;

  return (
    <div className={styles.container}>
      <H2>{he.decode(locale.WATCH_RECENTLY_TITLE || 'WATCH_RECENTLY_TITLE')}</H2>
      <div className={styles.cardsSlider}>
        {isTabletOrMobile ? (
          <div className={styles.sliderWrap}>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            {filterData.map((item: NoteInfo) => (
              <Card.GridNote
                className={styles.card}
                key={item.id}
                title={item.title}
                rating={item.rating}
                img={item.img}
                musicians={item.musicians}
                views={item.views}
                likes={item.likes}
                vote_count={item.vote_count}
                arrangement={item.arrangement}
                url={item.url}
                id={item.id}
                complexity={item.complexity}
              />
            ))}
          </div>
        ) : (
          <Slider {...settings}>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            {filterData.map((item: NoteInfo) => (
              <Card.GridNote
                className={styles.card}
                key={item.id}
                title={item.title}
                rating={item.rating}
                img={item.img}
                musicians={item.musicians}
                views={item.views}
                likes={item.likes}
                vote_count={item.vote_count}
                arrangement={item.arrangement}
                url={item.url}
                id={item.id}
                complexity={item.complexity}
              />
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default RecentlyViewed;
